<div class="inner-content">
  @if (title) {
    <cs-label class="group-title">{{ title }}</cs-label>
  }
  <!-- projected title slot for headings the string [title] input can't express
       (e.g. a name with a badge or tooltip beside it) -->
  <ng-content select="[group-title]"></ng-content>
  <ng-content select="cs-note"></ng-content>
  <ng-content></ng-content>
</div>
<ng-content select="cs-button"></ng-content>
